<template src="./Add.html"></template>

<script>
import { showAlert } from "@/utils/helpers";

export default {
  props: {
      
        doctorId: {
            type: Number,
            required: true,
        },
    },

  created() {
    this.vm.doctorId = this.doctorId;
    this.$store.dispatch("lookups/getLookups");

  },
  computed: {
    diseasesTypes() {
      return this.$store.getters["lookups/getLookupByType"](
        this.$lookupTypes.DiseasesTypes
      );
    },
    skinIssuesTypes() {
      return this.$store.getters["lookups/getLookupByType"](
        this.$lookupTypes.SkinIssuesTypes
      );
    },
  },
  data() {
    return {
      dialog: false,
      searchTrem: null,
      vm: {
        doctorId: null,
        patientId: null,
        diseases: [],
        skinIssues: []
      },
      patients: [],
      selectedPatient: {
        fullName: null,
        fileNo: null,
        gender: null,
        birthDate: null,
        bloodType: null,
      },
      showResult: false
    };
  },
  methods: {
    confirm() {
      this.$store
        .dispatch("patientsProcedures/add", this.vm)
        .then(() => {
          this.back();
        })
        .catch(() => { });
    },

    SearchPatient() {
      this.showResult = false;
      this.patients = [];
      this.selectedPatient = {
        fullName: null,
        fileNo: null,
        gender: null,
        birthDate: null,
        bloodType: null,
      };
      this.vm = {
        patientId: null,
        diseases: [],
        skinIssues: []
      };
      if (this.searchTrem == null || this.searchTrem == "") {
        showAlert(`الرجاء ادخال رقم الهاتف`);

        return false;
      }

      this.$store
        .dispatch("patientsProcedures/search", { searchTrem: this.searchTrem })
        .then((res) => {

          if (res.statusCode == 1) {
            this.showResult = true

            this.patients = res.patients;
            this.dialog = true;
          }
        })
        .catch(() => { });
    },
    confirmDialog() {
      let that = this;
      this.patients.forEach((el) => {
        if (that.vm.patientId == el.id) {
      
          that.selectedPatient = el
          return el
        }
      });
      this.dialog = false
    },
    back() {
      this.$emit("back");
    },
  },
};
</script>